import Vue from 'vue'
import App from './App.vue'
import store from './store'
import './assets/css/swisscom_colors.css'
import VueCookies from 'vue-cookies'
import i18n from '@/localization/i18n'
import Axios from 'axios'
import VueSlider from 'vue-slider-component'
import router from './router'
import 'vue-slider-component/theme/default.css'
import 'babel-polyfill'
import Keycloak from 'keycloak-js'

Vue.component('VueSlider', VueSlider)

Vue.use(VueCookies)

/**
 * Defines default behaviour for all requests
 */
Vue.prototype.$http = Axios
Vue.prototype.$http.defaults.withCredentials = true

Vue.config.ignoredElements = [/sdx-\w*/]

Vue.config.productionTip = false

let initOptions = {
   url: process.env.VUE_APP_KEYCLOAK_URL,
   realm: process.env.VUE_APP_KEYCLOAK_REALM,
   clientId: process.env.VUE_APP_KEYCLOAK_CLIENT_ID,
   onLoad: 'login-required'
}
let keycloak = new Keycloak(initOptions)
keycloak
   .init({ onLoad: initOptions.onLoad })
   .then(auth => {
      if (!auth) {
         window.location.reload()
      } else {
         console.log('logged in user is:' + keycloak.tokenParsed.name + ' mail:(' + keycloak.tokenParsed.email + ')')
         localStorage.setItem('user_name', `${keycloak.tokenParsed.family_name} ${keycloak.tokenParsed.given_name}`)
         localStorage.setItem('user_email', keycloak.tokenParsed.email)
         localStorage.setItem('access_token', keycloak.token)
         new Vue({
            router,
            store,
            i18n,
            render: h => h(App, { props: { keycloak: keycloak } })
         }).$mount('#app')
      }
      //Token Refresh
      setInterval(() => {
         keycloak
            .updateToken(70)
            .then(refreshed => {
               if (refreshed) {
                  localStorage.setItem('access_token', keycloak.token)
               }
            })
            .catch(() => {
               console.error('Failed to refresh token')
            })
      }, 6000)
   })
   .catch(() => {
      console.error('Authenticated Failed')
   })

Vue.prototype.$keycloak = keycloak
